import type {
  ArticleDividerComponent,
  ArticleHeadlineComponent,
  ArticleMediaComponent,
  ArticleParagraphComponent,
  ArticleWarningBoxComponent,
} from '@twisto/api-cms'

import type { RichTextBlock } from 'homepage/components/rich-text/rich-text.d'

import { Divider, Headline, Media, Paragraph, WarningBox } from '.'

export type ComponentsType =
  | ArticleDividerComponent
  | ArticleHeadlineComponent
  | ArticleMediaComponent
  | (ArticleParagraphComponent & { text?: RichTextBlock[] })
  | (ArticleWarningBoxComponent & { text?: RichTextBlock[] })

type Props = {
  components?: ComponentsType[]
}

// in genereted types components have __component with just string type
const ARTICLE_COMPONENTS = {
  divider: 'article.divider',
  headline: 'article.headline',
  media: 'article.media',
  paragraph: 'article.paragraph',
  warningBox: 'article.warning-box',
} as const

const COMPONENT_MAP = {
  [ARTICLE_COMPONENTS.divider]: Divider,
  [ARTICLE_COMPONENTS.headline]: Headline,
  [ARTICLE_COMPONENTS.media]: Media,
  [ARTICLE_COMPONENTS.paragraph]: Paragraph,
  [ARTICLE_COMPONENTS.warningBox]: WarningBox,
}

const ArticleComponent = ({ sectionData }: { sectionData: ComponentsType }) => {
  const componentName = sectionData.__component as keyof typeof COMPONENT_MAP
  const Component = COMPONENT_MAP[componentName]

  return <Component {...sectionData} />
}

export const ArticleComponents = ({ components }: Props) => (
  <>
    {components?.map((component, index) => (
      <ArticleComponent
        key={`${component.__component}${index}`}
        sectionData={component}
      />
    ))}
  </>
)
